import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import SEOManager from '@/components/seo/SEOManager';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { LangProvider } from '@/contexts/LangContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { Toaster } from '@/components/ui/sonner';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { QuickContactBar } from '@/components/layout/QuickContactBar';
import '@/App.css';

import HomePage from '@/pages/HomePage';
import CoursesPage from '@/pages/CoursesPage';
import CourseDetailPage from '@/pages/CourseDetailPage';
import PlacementTestPage from '@/pages/PlacementTestPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import CheckEmailPage from '@/pages/CheckEmailPage';
import VerifyEmailPage from '@/pages/VerifyEmailPage';
import StudentDashboard from '@/pages/StudentDashboard';
import TeacherDashboard from '@/pages/TeacherDashboard';
import PreferencesPage from "@/pages/PreferencesPage";
import LegalPage from '@/pages/LegalPage';
import EnrollPage from '@/pages/EnrollPage';
import CorporatePage from '@/pages/CorporatePage';
import ThankYouPage from '@/pages/ThankYouPage';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <SEOManager />
            <div className="min-h-screen flex flex-col">
              <Header />
              <QuickContactBar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/courses" element={<CoursesPage />} />
                  <Route path="/courses/:slug" element={<CourseDetailPage />} />
                  <Route path="/corporate" element={<CorporatePage />} />
                  <Route path="/placement-test" element={<PlacementTestPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/verify-email" element={<VerifyEmailPage />} />
                  <Route path="/verify-email/sent" element={<CheckEmailPage />} />
                  <Route path="/dashboard/student" element={<StudentDashboard />} />
                  <Route path="/dashboard/teacher" element={<TeacherDashboard />} />
                  <Route path="/preferences" element={<PreferencesPage />} />
                  <Route path="/enroll" element={<EnrollPage />} />
                  <Route path="/thank-you/inquiry-received" element={<ThankYouPage />} />
                <Route path="/legal/:slug" element={<LegalPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
